// 외주 커스텀 「임플란트 이름」 손으로 고치기 · 기억하기 (대표 2026-11-01 "각 그 자리에서 수동으로 수정할 수 있게")
//   이름 순서: ① 이 화면에서 이번에 고친 이름 > ② 기공소가 기억해 둔 이름(agentStatus/{labId}/priv/implantNames) > ③ PC 가 읽은 이름
//   기억 열쇠 = 원래 라이브러리 이름(에이전트 alpha.121~ 의 implants[].library). 옛 에이전트(alpha.116)는 library 가 없고 system 이 곧 원래 이름이라 그걸 쓴다.
//   순수 함수만 — 화면(OutsourceSend.js)과 시험(__tests__/implantNameEdit.test.js)이 같이 쓴다.

export const MAX_NAME = 40;          // firestore.rules mfDetailOk system 상한
export const MAX_REMEMBERED = 200;   // 한 기공소가 기억해 둘 수 있는 라이브러리 수

/** 라이브러리 이름 → 기억 문서의 칸 이름(영문 소문자·숫자·_ 만, 80자) */
export function keyOf(imp) {
    const raw = String((imp && (imp.library || imp.system)) || '').trim();
    if (!raw) return '';
    return raw.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 80);
}

/** 화면에 보일·보낼 이름 + 어디서 왔는지('edit' | 'remembered' | 'auto') */
export function nameOf(imp, caseKey, edits, remembered) {
    const k = keyOf(imp);
    const e = k && edits ? edits[`${caseKey}|${k}`] : '';
    if (e) return { name: e, from: 'edit' };
    const r = k && remembered ? remembered[k] : null;
    if (r && r.name) return { name: r.name, from: 'remembered' };
    return { name: String((imp && imp.system) || ''), from: 'auto' };
}

// 같은 연결부를 여러 회사 임플란트가 같이 쓰는 GeoMedi 코드(카탈로그 86쪽 GTS) — 고를 때 후보로 보여 준다
const CROSS = [
    { re: /geo\w*[\s_-]+0102(?!\d)|^suro_/i, names: ['Osstem TS', 'DIO UF Regular'] },
    { re: /geo\w*[\s_-]+0201(?!\d)|^der_/i, names: ['Dentium SuperLine', 'MegaGen AnyOne', 'Dentis S-Clean', 'NeoBiotech IS'] },
];

/** 고치기 후보: PC 가 읽은 이름 · 같은 연결부 다른 회사 · 이 기공소가 전에 기억한 이름들(중복 없이, 최대 12개) */
export function candidatesOf(imp, remembered) {
    const out = [];
    const add = (n) => { const v = String(n || '').trim().slice(0, MAX_NAME); if (v && !out.some((o) => o.toLowerCase() === v.toLowerCase())) out.push(v); };
    add(imp && imp.system);
    const lib = String((imp && (imp.library || imp.system)) || '');
    CROSS.filter((c) => c.re.test(lib)).forEach((c) => c.names.forEach(add));
    Object.values(remembered || {}).forEach((r) => r && add(r.name));
    return out.slice(0, 12);
}

/** 입력값 다듬기 — 앞뒤 공백·줄바꿈 제거, 40자 */
export function cleanName(v) {
    return String(v || '').replace(/[\r\n\t]+/g, ' ').replace(/\s+/g, ' ').trim().slice(0, MAX_NAME);
}
